function CountryOptions({ country }) {
  return (
    <>
      <option value={country}>{country}</option>
    </>
  );
}

export default CountryOptions;
